import * as React from 'react';

/**
 * Context value exposed by DraftChatProvider.
 * When draftId is non-null the chat is in "test mode" — per-message operations
 * (e.g. video generation) should target the draft endpoints instead of the
 * live chat ones, and the AI message text must be supplied by the caller since
 * draft replies aren't persisted to the Message table.
 */
export interface DraftChatContextValue {
  draftId: string | null;
}

export const DraftChatContext = React.createContext<DraftChatContextValue>({ draftId: null });

/** Read the draft chat context. Returns { draftId: null } when outside a provider. */
export const useDraftChatContext = (): DraftChatContextValue => React.useContext(DraftChatContext);
